import CityPageTemplate from "../city-template/CityPageTemplate";
import { athensOhConfig } from "./data";

export default function AthensOhPage() {
  return <CityPageTemplate config={athensOhConfig} />;
}